import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { services } from "../data/services";

export default function ServicesIndex() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="services-index-page" className="pt-24 pb-16">
      <div className="max-w-[1280px] mx-auto px-6 mb-8">
        <nav className="flex items-center gap-2 text-sm text-[#a6b3c8]" style={{ fontFamily: "Sora, sans-serif" }}>
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight size={14} className="opacity-60" />
          <span className="text-white">Services</span>
        </nav>
      </div>

      <section className="mb-14">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="max-w-3xl">
            <div className="section-eyebrow">Our services</div>
            <h1 className="section-title" data-testid="services-index-title">
              Six specialised practices, one accountable delivery team
            </h1>
            <p className="section-subtitle">
              We combine deep vertical expertise in aviation and enterprise IT with hands-on engineering. Every practice below is delivered end-to-end — from advisory through implementation to long-term support.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s, i) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`services-index-card-${i}`}
                className="glass-card p-4 flex flex-col group no-underline"
              >
                <div className="img-wrap aspect-[16/10] mb-5">
                  <img src={s.image} alt={s.title} loading="lazy" />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 45%, rgba(5,16,31,0.85) 100%)" }} />
                  <div className={`svc-icon ${s.iconCls} absolute top-3 left-3`} style={{ width: 40, height: 40, background: "rgba(5,16,31,0.7)", borderColor: "rgba(255,255,255,0.15)" }}>
                    {s.icon}
                  </div>
                </div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-[#7fa5e6] mb-1.5 px-1.5" style={{ fontFamily: "Sora, sans-serif" }}>{s.tagline}</div>
                <h3 className="text-white text-xl font-semibold mb-2 px-1.5" style={{ fontFamily: "Sora, sans-serif" }}>{s.title}</h3>
                <p className="text-[#a6b3c8] text-[14px] leading-relaxed px-1.5 mb-4 flex-1">{s.short}</p>
                <div className="px-1.5 pb-2 inline-flex items-center gap-2 text-[#7fa5e6] text-sm font-medium group-hover:text-white transition-colors" style={{ fontFamily: "Sora, sans-serif" }}>
                  Explore practice <ArrowRight size={16} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="mt-16">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="p-8 md:p-10 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-6" style={{ background: "linear-gradient(135deg, rgba(31,74,155,0.22), rgba(31,107,91,0.10))", border: "1px solid rgba(59,116,209,0.32)" }}>
            <div>
              <h3 className="text-white text-2xl font-semibold mb-1" style={{ fontFamily: "Sora, sans-serif" }}>
                Not sure where to start?
              </h3>
              <p className="text-[#a6b3c8]">Book a 30-minute discovery call with our engineering team.</p>
            </div>
            <Link to="/contact" className="btn-primary shrink-0">
              Talk to an Expert <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
